"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_redux_1 = require("react-redux");
const slice_1 = __importDefault(require("../../../app-reduxs/app/slice"));
const Colors_1 = __importDefault(require("../../../assets/colors/Colors"));
const EyeLogin_1 = __importDefault(require("../../../assets/icons/EyeLogin"));
const EyeSlashLogin_1 = __importDefault(require("../../../assets/icons/EyeSlashLogin"));
const components_1 = require("../../../components");
const InputField_1 = __importDefault(require("../../../components/input/InputField"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const ChangePassword = (props) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [email, setEmail] = (0, react_1.useState)("");
    const [errEmail, setErrorEmail] = (0, react_1.useState)("");
    const [password, setPassword] = (0, react_1.useState)("");
    const [errPassword, setErrPassword] = (0, react_1.useState)("");
    const [isShowPassWord, setShowPassword] = (0, react_1.useState)(false);
    const [isShowPassWordConfirm, setShowPasswordConfirm] = (0, react_1.useState)(false);
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.Pressable, { style: {
            flex: 1,
            backgroundColor: "#F7F7F7",
            justifyContent: "space-between",
        }, onPress: react_native_1.Keyboard.dismiss, disabled: helpler_1.isWeb },
        react_1.default.createElement(react_native_1.View, null,
            react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: "center" }, titleStyle: {
                    alignSelf: "center",
                    paddingRight: (0, scale_1.scale)(20),
                    fontSize: 14,
                }, title: "パスワードを忘れた方", styleContainer: {
                    backgroundColor: Colors_1.default.white,
                }, onLeftPress: () => {
                    (0, rootNavigation_1.goBack)();
                } }),
            react_1.default.createElement(react_native_1.KeyboardAvoidingView, null,
                react_1.default.createElement(react_native_1.View, { style: styles_1.default.main },
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row" } },
                        react_1.default.createElement(react_native_1.View, { style: styles_1.default.Rectangle }),
                        react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                                fontSize: (0, scale_1.moderateScale)(16),
                                lineHeight: (0, scale_1.moderateScale)(24),
                                color: "#292A33",
                                paddingLeft: (0, scale_1.scale)(8),
                            } }, "\u30D1\u30B9\u30EF\u30FC\u30C9\u518D\u8A2D\u5B9A")),
                    react_1.default.createElement(CustomText_1.default, { style: {
                            fontSize: (0, scale_1.moderateScale)(15),
                            lineHeight: (0, scale_1.moderateScale)(23),
                            color: "#292A33",
                            fontWeight: "300",
                            marginTop: 12,
                        } }, "\u65B0\u3057\u304F\u8A2D\u5B9A\u3059\u308B\u30D1\u30B9\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044\u3002"),
                    react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", placeholderTextColor: "#C8C8C8", label: "新しいパスワード", value: email, onChangeText: (text) => {
                            setEmail(text?.trim());
                            setErrorEmail("");
                        }, secureTextEntry: !isShowPassWord, rightIcon: isShowPassWord ? (react_1.default.createElement(EyeSlashLogin_1.default, { style: styles_1.default.iconInputLogin })) : (react_1.default.createElement(EyeLogin_1.default, { style: styles_1.default.iconInputLogin })), onRightIconPress: () => {
                            setShowPassword(!isShowPassWord);
                        } }),
                    errEmail && react_1.default.createElement(CustomText_1.default, { style: styles_1.default.err }, errEmail),
                    react_1.default.createElement(react_native_1.View, { style: { flexDirection: "row", marginTop: 8 } },
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(11),
                                lineHeight: (0, scale_1.moderateScale)(19),
                                color: "#545454",
                                fontWeight: "300",
                            } }, "\u203B"),
                        react_1.default.createElement(CustomText_1.default, { style: {
                                fontSize: (0, scale_1.moderateScale)(11),
                                lineHeight: (0, scale_1.moderateScale)(19),
                                color: "#545454",
                                fontWeight: "300",
                            } }, "\u534A\u89D2\u82F1\u6570\u5B578\u6841\u4EE5\u4E0A20\u6841\u4EE5\u5185\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044")),
                    react_1.default.createElement(InputField_1.default, { style: styles_1.default.input, placeholder: "\u30E1\u30FC\u30EB\u30A2\u30C9\u30EC\u30B9", placeholderTextColor: "#C8C8C8", label: "パスワード(確認用)", value: password, onChangeText: (text) => {
                            setPassword(text?.trim());
                            setErrPassword("");
                        }, secureTextEntry: !isShowPassWordConfirm, rightIcon: isShowPassWordConfirm ? (react_1.default.createElement(EyeSlashLogin_1.default, { style: styles_1.default.iconInputLogin })) : (react_1.default.createElement(EyeLogin_1.default, { style: styles_1.default.iconInputLogin })), onRightIconPress: () => {
                            setShowPasswordConfirm(!isShowPassWordConfirm);
                        } }),
                    errPassword && (react_1.default.createElement(CustomText_1.default, { style: styles_1.default.err }, errPassword)),
                    react_1.default.createElement(components_1.SimpleButton, { onPress: () => {
                            dispatch(slice_1.default.actions.showToast("パスワードを設定しました"));
                            props.navigation.navigate("NOTIFICATION_CHANGE_PASSWORD");
                        }, title: "\u30ED\u30B0\u30A4\u30F3\u753B\u9762\u306B\u623B\u308B", style: styles_1.default.buttonSend }))))));
};
exports.default = ChangePassword;
